/**
 * PrivateRoute
 * From: 1.0.0
 *
 * @packageDocumentation
 */

import Keycloak from 'keycloak-js';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { ObjectType } from '../utils/UtilityTypes';

export type AuthContext<S extends ObjectType = ObjectType> = {
  isAuth: boolean;
  setIsAuth: Consumer<boolean>;
} & S;

type PrivateRouteProps = { keycloak: Keycloak };

const PrivateRoute = ({ keycloak }: PrivateRouteProps) => {
  const location = useLocation();

  if (keycloak.authenticated) {
    return <Outlet />;
  }

  return <Navigate to="/" /* state={{ from: location.pathname }} */ />;
};

export default PrivateRoute;
